import * as m from "../../model/model";

import { AudioData } from "../../pages/app/lessons/Lessons.service";
import { api } from "../../api/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { userActions } from "./userSlice";

/* export const completeLessonThunk = createAsyncThunk<
  m.Lesson,
  { user: m.User; lesson: m.Lesson }
>("lesson/complete", async ({ user, lesson }, { dispatch }) => {
  if (user) {
    const status = await api.app.updateProgress(user, lesson.uid);
    if (status.ok) dispatch(lessonActions.setLesson(lesson));
  }
  return lesson;
}); */

export const sessionLoginThunk = createAsyncThunk<
  void,
  { email: string; idToken: string; csrfToken: string }
>("app/sessionLogin", ({ email, idToken, csrfToken }, { dispatch }) => {
  return api.login
    .sessionLogin({ email, idToken, csrfToken })
    .then((loggedUser) => {
      dispatch(userActions.setUser(loggedUser || null));
    })
    .catch((error) => {
      dispatch(userActions.setError(error));
    });
});

export const logoutAppUserThunk = createAsyncThunk<void>(
  "app/logoutUser",
  async (_, { dispatch }) => {
    await api.login.logOutUser();
    dispatch(userActions.setUser(null));
  }
);

export const updateAppUserThunk = createAsyncThunk<m.User, m.User>(
  "app/updateUser",
  async (user, { dispatch }) => {
    const updatedUser = await api.app.updateUser(user);
    dispatch(userActions.setUser(updatedUser));
    return updatedUser;
  }
);

export const getOverviewCoursesThunk = createAsyncThunk<m.CourseOverview[]>(
  "app/getOverviewCourses",
  async (_, { dispatch }) => {
    const courses = await api.app.getOverviewCourses();
    dispatch(userActions.setCoursesOverview(courses));
    return courses;
  }
);

export const setCurrentCourseThunk = createAsyncThunk<
  m.User,
  { email: string; course: string }
>("app/setCurrentCourse", async ({ email, course }, { dispatch }) => {
  const user = await api.app.setCurrentCourse(email, course);
  dispatch(userActions.setUser(user));
  return user;
});

export const updateAudioProgressThunk = createAsyncThunk<
  m.User,
  { audio: AudioData }
>(
  "app/updateAudioProgress",
  async ({ audio }, { dispatch, rejectWithValue }) => {
    try {
      const user = await api.app.audioCompleted(audio);
      dispatch(userActions.setUser(user));
      return user;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const updateLessonMaterialThunk = createAsyncThunk<
  m.User,
  { material: m.Material; page: number; scale: number }
>(
  "app/updateLessonMaterial",
  async ({ page, scale, material }, { dispatch }) => {
    const user = await api.app.updateLessonMaterial(material.uid, page, scale);
    dispatch(userActions.setUser(user));
    return user;
  }
);
